module.exports = __webpack_public_path__ + "static/media/CNBC_Logo_Black.da12cf4a.png";